import { setElementHtml } from '@local_modules/generic/dom/set-element-html'
import { callApi } from '@local_modules/generic/fetch.js'

export default function showSyncActions (params) {
  const { containerElementId, dataSyncApiResponse } = params

  if (dataSyncApiResponse.status === 'ongoing') {
    const html = '<button class="button is-warning" id="stop-sync-button" data-action="stop-sync">Stop Sync</button>'
    setElementHtml(containerElementId, html)

    document.getElementById('stop-sync-button').addEventListener('click', async (event) => {
      event.preventDefault()
      event.target.classList.add('is-loading')
      await stopSync(dataSyncApiResponse.id)
      event.target.classList.remove('is-loading')
      window.location.reload()
    })
  } else {
    setElementHtml(containerElementId, '')
  }
}

async function stopSync (dataSyncId) {
  await callApi('/api/data-sync/:dataSyncId/stop', {
    dataSyncId
  }, { method: 'PUT' })
}
